export default __webpack_public_path__ + "static/media/twitter.67a9d4ed.svg";